import { PlatformSlug } from 'constants/consts'
import { CourseName } from 'theme/utils'
import {
  COMMUNITY_TESTLETS_TAB_INDEX,
  OSCE_MULTI_SELECT_QB_TAB_INDEX,
  OSCE_RX_WRITING_QB_TAB_INDEX,
  OSCE_STANDALONE_QB_TAB_INDEX,
} from '../utils'
import { List } from './List'

export const OSCEStandaloneQBankList = () => (
  <List
    override={{
      tabIndex: String(OSCE_STANDALONE_QB_TAB_INDEX),
      availablePlatforms: [PlatformSlug.NDEBCrusher],
    }}
  />
)

export const OSCEMultiselectQBankList = () => (
  <List
    override={{
      tabIndex: String(OSCE_MULTI_SELECT_QB_TAB_INDEX),
      availablePlatforms: [PlatformSlug.NDEBCrusher],
      filterSubjects: ({ tabName }) => tabName !== CourseName.Pharmacology,
    }}
  />
)

export const OSCERxWritingQBankList = () => (
  <List
    override={{
      tabIndex: String(OSCE_RX_WRITING_QB_TAB_INDEX),
      availablePlatforms: [PlatformSlug.NDEBCrusher],
      filterSubjects: ({ tabName }) => tabName === CourseName.Pharmacology,
    }}
  />
)

export const CommunityTestletsList = () => (
  <List
    override={{
      tabIndex: String(COMMUNITY_TESTLETS_TAB_INDEX),
      availablePlatforms: [PlatformSlug.NBDHEBooster],
      filterSubjects: ({ tabName }) => tabName === CourseName.CommunityHealth,
    }}
  />
)
